import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { CustomerSimpleView } from 'domains/Customer/components'

const CustomerList = (props) => {
  const { customers, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {customers?.length > 0 ? (
        customers?.map((customer, index) => (
          <Col
            mb={4}
            key={customer?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <CustomerSimpleView
              actions={actions}
              index={index}
              isSelected={customer?._id === selectedItem}
              onSelect={setSelectedItem}
              customer={customer}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No customers have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

CustomerList.propTypes = {
  customers: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default CustomerList
